// extracted by mini-css-extract-plugin
export var activeDarkBg = "link-module--activeDarkBg--5f695";
export var activeLightBg = "link-module--activeLightBg--2369f";
export var linkStyle = "link-module--linkStyle--444ce";